// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__7lIdO","footer":"ModalFilter_footer__3qLt1"};